const residentialTimeOfUse = () => {
  return {
    name: 'RS-TOU-3P',
    title: 'Residential Time of Use',
    rateElements: [
      {
        rateElementType: 'FixedPerMonth',
        name: 'Service Charge',
        rateComponents: [
          {
            charge: 0.0,
            name: 'Service Charge with NJ Sales and Use Tax (SUT)',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Summer On-Peak',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.587391,
            months: [5, 6, 7, 8],
            daysOfWeek: [1, 2, 3, 4, 5],
            hourStarts: [16, 17, 18, 19, 20, 21],
            name: 'Summer On-Peak',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Summer Mid-Peak Weekday',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.262116,
            months: [5, 6, 7, 8],
            daysOfWeek: [1, 2, 3, 4],
            hourStarts: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            name: 'Summer Mid-Peak Weekday',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Summer Mid-Peak Sunday',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.262116,
            months: [5, 6, 7, 8],
            daysOfWeek: [0],
            hourStarts: [
              0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
              20, 21, 22, 23,
            ],
            name: 'Summer Mid-Peak Sunday',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Summer Mid-Peak Saturday',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.262116,
            months: [5, 6, 7, 8],
            daysOfWeek: [6],
            hourStarts: [
              6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
              23,
            ],
            name: 'Summer Mid-Peak Saturday',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Summer Off-Peak',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.092476,
            months: [5, 6, 7, 8],
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
            hourStarts: [0, 1, 2, 3, 4, 5],
            name: 'Summer Off-Peak',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Winter On-Peak',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.372825,
            months: [0, 1, 2, 3, 4, 9, 10, 11],
            daysOfWeek: [1, 2, 3, 4, 5],
            hourStarts: [16, 17, 18, 19, 20, 20, 21],
            name: 'Winter On-Peak',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Winter Off-Peak',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.019817,
            months: [0, 1, 2, 3, 4, 9, 10, 11],
            daysOfWeek: [0, 6],
            hourStarts: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 20, 21, 22, 23,
            ],
            name: 'Winter Off-Peak',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Winter Mid-Peak Weekday',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.25326,
            months: [5, 6, 7, 8],
            daysOfWeek: [0, 1, 2, 3, 4],
            hourStarts: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            name: 'Winter Mid-Peak Weekday',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Winter Mid-Peak Sunday',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.25326,
            months: [5, 6, 7, 8],
            daysOfWeek: [0],
            hourStarts: [
              0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
              20, 21, 22, 23,
            ],
            name: 'Winter Mid-Peak Sunday',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution Charges - Winter Mid-Peak Saturday',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.25326,
            months: [5, 6, 7, 8],
            daysOfWeek: [6],
            hourStarts: [
              6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
              23,
            ],
            name: 'Winter Mid-Peak Saturday',
          },
        ],
      },
    ],
  };
};

export default residentialTimeOfUse;
